// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { ContentArea } from "#/components/content_area/ContentArea";

@Component({
  mixins: [template],
  components: {
    ContentArea,
  },
})
export default class ModuleWrapper extends Vue {
  @Prop({ default: () => ({}) })
  public instance!: object;

  @Prop({ default: null })
  public additionalClasses!: string;

  @Prop({ default: null })
  public backgroundColor!: string;

  @Prop({ default: false })
  public noExtraSpacing!: boolean;

  private alreadyAnimated: boolean = false;

  private animationDone: boolean = false;

  get classList() {
    let baseClasses = [
      // 'wb-content-area',
      "module",
    ];

    if (this.backgroundColor) {
      baseClasses.push(this.backgroundColor);
    }

    if (this.backgroundColor == "white" && !this.noExtraSpacing) {
      baseClasses.push("extra-spacing");
    }

    let additionalClasses = this.additionalClasses
      ? this.additionalClasses.split(" ")
      : [];

    return baseClasses.concat(additionalClasses);
  }

  get instanceHash() {
    return this.hash(JSON.stringify(this.instance));
  }

  private hash(s) {
    let hash = 0,
      i,
      chr;
    if (s.length === 0) return hash;
    for (i = 0; i < s.length; i++) {
      chr = s.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  get styles() {
    let styleObj = {};

    if (
      this.instance["common_options"] &&
      this.instance["common_options"]["margin-top"]
    ) {
      styleObj["margin-top"] =
        this.instance["common_options"]["margin-top"] + "px";
    }

    if (
      this.instance["common_options"] &&
      this.instance["common_options"]["margin-bottom"]
    ) {
      styleObj["margin-bottom"] =
        this.instance["common_options"]["margin-bottom"] + "px";
    }

    if (
      this.instance["common_options"] &&
      this.instance["common_options"]["padding-top"]
    ) {
      styleObj["padding-top"] =
        this.instance["common_options"]["padding-top"] + "px";
    }

    if (
      this.instance["common_options"] &&
      this.instance["common_options"]["padding-bottom"]
    ) {
      styleObj["padding-bottom"] =
        this.instance["common_options"]["padding-bottom"] + "px";
    }

    return styleObj;
  }

  get animation() {
    let animation = "fadeInUp";

    if (
      this.instance["common_options"] &&
      this.instance["common_options"]["animation"]
    ) {
      animation = this.instance["common_options"]["animation"];
    }

    if (animation == "no-animation") {
      animation = "";
    }

    return animation;
  }

  get animationClassList() {
    if (this.alreadyAnimated && !this.animationDone) {
      return ["animated", this.animation];
    } else {
      return [];
    }
  }

  get anker() {
    let anker = null;

    if (
      this.instance["common_options"] &&
      this.instance["common_options"]["anker"] != ""
    ) {
      anker = this.instance["common_options"]["anker"];
    }

    return anker;
  }

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll(null);
    (this.$refs["animation"] as HTMLElement).addEventListener(
      "animationend",
      () => {
        this.animationDone = true;
      }
    );
  }

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    if (this.animation && !this.alreadyAnimated) {
      if (
        window.innerHeight + this.getWindowScrollTop() >
        this.offsetTop(this.$el)
      ) {
        this.alreadyAnimated = true;
      }
    }
  }

  getWindowScrollTop() {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";

    return supportPageOffset
      ? window.pageYOffset
      : isCSS1Compat
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
  }

  offsetTop(el: Element) {
    let rect = el.getBoundingClientRect();
    return rect.top + document.body.scrollTop;
  }
}
